var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedIn = function SvgLinkedIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#151D26",
    d: "M3.633 15.934V5.814H.203v10.12zM1.918 4.43c1.196 0 1.94-.778 1.94-1.749C3.838 1.69 3.115.934 1.942.934S0 1.689 0 2.682c0 .971.744 1.749 1.895 1.749zm3.613 11.503h3.43v-5.652c0-.303.023-.605.114-.821.248-.604.812-1.23 1.76-1.23 1.24 0 1.737.928 1.737 2.288v5.415h3.43V10.13c0-3.11-1.692-4.555-3.949-4.555-1.85 0-2.663 1.014-3.114 1.705h.023V5.813h-3.43c.045.95 0 10.12 0 10.12"
  })));
};
export default SvgLinkedIn;